import { Box, Spinner, Text } from '@chakra-ui/react'
import { createFileRoute } from '@tanstack/react-router'

import { useBrief } from '@/features/brief/api'
import { Workspace } from '@/features/brief/Workspace'

// Hoisted: an object literal in JSX would be a new prop on every render.
const gutter = { base: 4, md: 7 }

export const Route = createFileRoute('/app/briefs/$briefId')({
  component: BriefRoute,
})

/**
 * A brief owned by a buyer, reached by its id.
 *
 * Readable by every member of that buyer. An anonymous brief never appears
 * here: it is reached at /brief, through the cookie that holds it.
 */
function BriefRoute() {
  const { briefId } = Route.useParams()
  const brief = useBrief(briefId)

  if (brief.isPending) {
    return (
      <Box flex="1" px={gutter} py="6">
        <Spinner />
      </Box>
    )
  }

  if (brief.isError) {
    return (
      <Box flex="1" overflowY="auto" px={gutter} py="6">
        <Text role="alert" color="rust.fg" maxW="thread" mx="auto">
          {brief.error.message}
        </Text>
      </Box>
    )
  }

  return (
    <Workspace
      // Keyed by the brief, so navigating between two of them opens a stream on
      // the one now on screen rather than leaving the previous one running.
      key={briefId}
      streamPath={`/briefs/${briefId}/stream`}
      messagesPath={`/briefs/${briefId}/messages`}
      // Owned, so it can be checked against the corpus. The held brief passes
      // nothing here and gets no button: an anonymous brief is never matched.
      evaluates={briefId}
    />
  )
}
